import React, { useState } from "react";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Divider from "@mui/material/Divider";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function CardExpandable({ actions, children, defaultExpanded = false }) {
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <>
      <Divider sx={{ mb: 1 }} />

      <Box display="flex" alignItems="center" justifyContent="space-between">
        <IconButton
          size="small"
          aria-expanded={expanded}
          onClick={() => setExpanded(!expanded)}
          aria-label="show more"
          sx={{
            transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.3s",
          }}
        >
          <ExpandMoreIcon />
        </IconButton>
        <Box>
          {actions}
        </Box>
      </Box>

      <Collapse in={expanded} timeout="auto" unmountOnExit>
        {children}
      </Collapse>
    </>
  );
}


